import Model from 'flarum/common/Model';

/**
 * A wiki category (e.g. "Guides", "Reference") used to organise articles.
 */
export default class WikiCategory extends Model {
  name = (() => Model.attribute('name'))();
  slug = (() => Model.attribute('slug'))();
  description = (() => Model.attribute('description'))();
  color = (() => Model.attribute('color'))();
  icon = (() => Model.attribute('icon'))();
  position = (() => Model.attribute('position'))();
  articleCount = (() => Model.attribute('articleCount'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  updatedAt = (() => Model.attribute('updatedAt', Model.transformDate))();
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiCategory', WikiCategory);